import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { CoinflipService } from '../coinflip.service';
import { CoinflipModalTopComponent } from './coinflip-modal-top/coinflip-modal-top.component';
import { CoinflipModalUserComponent } from './coinflip-modal-user/coinflip-modal-user.component';
import { ModalService } from '@app/modal/modal.service';
import { NotificationService } from '@app/notification/notification.service';
import { Coinflip } from '@models/coinflip.interface';
import { IconComponent } from '@shared/icon/icon.component';
import { ModalBoxComponent } from '@shared/modal-box/modal-box.component';

@Component({
  selector: 'app-coinflip-view-modal',
  templateUrl: './coinflip-view-modal.component.html',
  styleUrls: ['./coinflip-view-modal.component.scss'],
  imports: [ModalBoxComponent, CoinflipModalTopComponent, CoinflipModalUserComponent, IconComponent, RouterLink],
})
export class CoinflipViewModalComponent implements OnInit, OnDestroy {
  coinflip: Coinflip;
  subscription: Subscription;

  showUserAnimation = false;

  constructor(public modalService: ModalService, private coinflipService: CoinflipService, private notificationsService: NotificationService) {
    this.coinflip = this.modalService.data;
    this.modalService.disableWrapperOverflow = true;

    if ('winner' in this.coinflip) {
      this.showUserAnimation = true;

      setTimeout(() => {
        this.showUserAnimation = false;
      }, 4500);
    }
  }

  ngOnInit() {
    this.subscription = this.coinflipService.onCoinflipChange.subscribe((cf) => {
      if (cf.gameid === this.coinflip.gameid) {
        this.coinflip = cf;
      }
    });
  }

  async cancelCoinflip() {
    await this.coinflipService.cancelCoinflip(this.coinflip);
    this.notificationsService.success('Coinflip was cancelled successfully', 'Cancel coinflip');
    this.modalService.close();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
